export const LANGUAGE_STORAGE_KEY = 'game-language'

export const DEFAULT_LANGUAGE = 'id'

export const SUPPORTED_LANGUAGES = ['id', 'en']
